// @ts-ignore
import makeInspectable from 'mobx-devtools-mst'
import * as React from 'react'

import { getDefaultStore, RootStore } from './root.store'

export const StoreContext = React.createContext<RootStore>({} as RootStore)

export const useStore = () => React.useContext(StoreContext)

export const StoreProvider: React.FC = ({ children }) => {
  const [defaultStore, setDefaultStore] = React.useState<RootStore | undefined>(undefined)
  React.useEffect(() => {
    const loadStoreFromStorage = async () => {
      console.log('loadStoreFromStorage')
      const store = await getDefaultStore()
      if (__DEV__) {
        makeInspectable(store)
      }
      setDefaultStore(store)
    }
    loadStoreFromStorage()
  }, [])

  // const store = useLocalObservable(() => defaultStore)
  // console.log('setup store', !!store)
  if (defaultStore) {
    return <StoreContext.Provider value={defaultStore}>{children}</StoreContext.Provider>
  }
  return null
}

export default StoreProvider
